import { Dispatch } from 'redux';

import { TwilioClient } from 'ha/types/Twilio';
import { EventTypes } from '../constants';
import { receiveMessage } from '../actions';

export default (dispatch: Dispatch, client: TwilioClient, channelId: string) =>
  client.getChannelByUniqueName(channelId).then(userChannel =>
    userChannel.on(EventTypes.messageAdded, ({ state }) =>
      dispatch(
        receiveMessage({
          ...state,
          body: JSON.parse(state.body),
        }),
      ),
    ),
  );
